/** Sentinel value for "no paid promotion" in shared card selectors (not a `ToplistingVariant`). */
export const TOPLISTING_PROMOTION_NONE = 'NO_PROMOTION';

/** Regional Highlight is a slot-backed visibility product, not a ToplistingVariant. */
export const REGIONAL_HIGHLIGHT_PROMOTION_VALUE = 'REGIONAL_HIGHLIGHT';

/** NC Boost is stored on the listing (`newConstructionData.projectType`), not a ToplistingVariant. */
export const PROJECT_BOOST_PROMOTION_VALUE = 'PROJECT_BOOST';

/** Border / top-accent color for Premium promotion card (first in row). */
export const TOPLISTING_PROMOTION_CARD_ACCENT_PREMIUM = '#101968';

/** Border / top-accent for Top Listing card (default selection). */
export const TOPLISTING_PROMOTION_CARD_ACCENT_TOP = '#0E6969';

/** Border / top-accent for Lifetime Top Listing card. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_LIFETIME = '#8DA2B4';

/** Regional Highlight uses the neutral dove accent from the product design. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_REGIONAL_HIGHLIGHT = '#8DA2B4';

/** Top Listing Abo uses the same accent as daily Top. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_TOP_ABO = TOPLISTING_PROMOTION_CARD_ACCENT_TOP;

/** NC Boost uses the neutral dove accent, like Regional Highlight. */
export const TOPLISTING_PROMOTION_CARD_ACCENT_PROJECT_BOOST =
  TOPLISTING_PROMOTION_CARD_ACCENT_REGIONAL_HIGHLIGHT;

/** TODO: replace with the pricing API value once NC Boost pricing is exposed (ASR-1728). */
export const PROJECT_BOOST_PRICE_CHF = 11.7;

/** Selected-card background by column index (repeats for 4+ cards). */
export const TOPLISTING_PROMOTION_CARD_SELECTED_BACKGROUNDS = [
  '#f5f6ff',
  '#f2ffff',
  '#f5f6ff',
] as const;

/** One-time fee for rental listings (Flex Rent) in CHF */
export const FLEX_RENT_PRICE_CHF = 370;

/** One-time fee for sale listings (Flex Buy) in CHF */
export const FLEX_BUY_PRICE_CHF = 505;

/** Flex package pricing configuration */
export const FLEX_PACKAGE_PRICING = {
  RENT: FLEX_RENT_PRICE_CHF,
  BUY: FLEX_BUY_PRICE_CHF,
} as const;
